import { makeStyles, RadioGroup as MuiRadioGroup } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import FormControlRadio from '~components/radio/form-control-radio';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.flex.row,
    ...theme.flex.crossCenter,
    '& > *:not(:first-child)': { marginLeft: 16 },
  },
}));

const RadioGroup = React.forwardRef((props, ref) => {
  const { radios, className, radioClassName, disabled, ...otherProps } = props;
  const classes = useStyles();

  return (
    <MuiRadioGroup ref={ref} className={`${classes.root} ${className}`} {...otherProps}>
      {radios.map((item) => (
        <FormControlRadio
          key={item.value}
          className={radioClassName}
          disabled={disabled ?? item.disabled}
          {...item}
        />
      ))}
    </MuiRadioGroup>
  );
});

RadioGroup.propTypes = {
  className: PropTypes.string,
  radioClassName: PropTypes.string,
  radios: PropTypes.arrayOf(PropTypes.object).isRequired,
  disabled: PropTypes.bool,
};

export default RadioGroup;
